import React, { useEffect } from "react";
import { Counter } from "./features/counter/Counter";
import { Demo } from "./pages/Demo";
import { CheckoutInfo } from "./pages/CheckoutInfo";
import { CheckoutPayment } from "./pages/CheckoutPayment";
import { CheckoutCustomise } from "./pages/checkout/customise";
import { ThreeDSAuth } from "./pages/checkout/3ds-auth";
import "./App.scss";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { LoadingProgress } from "./components/basic/LoadingProgress";
import { selectLoadingProgressStatus } from "./components/basic/LoadingProgress/loadingProgressSlice";
import { NotificationBar } from "./components/basic/NotificationBar/NotificationBar";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header/Header";
import { getCookie } from "./core/helpers";
import { getUserInfo } from "./core/store/authSlice";
import ReactGA from "react-ga";

function App() {
  const loadingStatus = useAppSelector(selectLoadingProgressStatus);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = getCookie("registered_user");
    if (token) {
      dispatch(getUserInfo());
    }
  }, []);

  useEffect(() => {
    ReactGA.initialize("G-80ZZ44BFFB");
    ReactGA.pageview(window.location.pathname + window.location.search); // first pageview, other pageview on header
  }, []);

  return (
    <BrowserRouter>
      <div className="App">
        {loadingStatus === 1 ? <LoadingProgress /> : <></>}
        <Routes>
          <Route path="/">
            <Route index element={<Counter />} />
          </Route>
          <Route path="/demo">
            <Route
              index
              element={
                <>
                  <Header></Header>
                  <Demo />
                  <Footer />
                </>
              }
            />
          </Route>
          <Route path="/checkout/info/:sel/:registration">
            <Route
              index
              element={
                <>
                  <CheckoutInfo />
                </>
              }
            />
          </Route>
          <Route path="/checkout/payment/:registration">
            <Route
              index
              element={
                <>
                  <CheckoutPayment />
                </>
              }
            />
          </Route>
          <Route path="/checkout/customise/:registration">
            <Route
              index
              element={
                <>
                  <CheckoutCustomise />
                </>
              }
            />
          </Route>
          <Route path="/checkout/3ds-auth">
            <Route index element={<ThreeDSAuth />} />
          </Route>
        </Routes>
        <NotificationBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
